import request from '@/utils/request'

let DepartmentApi = {

  /*医院/科室管理列表*/
  list(data) {
    return request._post('/shop/plus.department.Index/index', data);
},
/*添加医院/科室管理*/
add(data) {
    return request._post('/shop/plus.department.Index/add', data);
},
/*修改医院/科室管理*/
edit(data) {
    return request._post('/shop/plus.department.Index/edit', data);
},
/*删除医院/科室管理*/
del(data) {
    return request._post('/shop/plus.department.Index/del', data);
},
/*医院/科室管理详情*/
detail(data) {
  return request._post('/shop/plus.department.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.department.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.department.Setting/getSetting', data, errorback);
    },
}
export default DepartmentApi;



// WEBPACK FOOTER //
// ./src/api/department.js